import { rufe } from './client';

/**
 * Die Storno- und Umbuchungsstaffeln (BUC-45).
 *
 * Alle Sätze als ZEICHENKETTEN: `15.0000` ist als JSON-Zahl darstellbar,
 * `0.1` nicht exakt — und über eine Gleitkommazahl liefe der Satz, an dem die
 * Gebühr hängt (RND-01).
 */

export type Stufe = {
  readonly abTagenVorTermin: number;
  readonly prozent: string | null;
  readonly nichtVorgesehen: boolean;
};

export type Staffelzeile = {
  readonly id: string;
  readonly kennung: string;
  readonly bezeichnung: string;
  readonly kundenart: 'privat' | 'firma';
  readonly vorgangsart: 'storno' | 'umbuchung' | 'teilnehmerwechsel';
  readonly vertragsart: string;
  readonly artikel: string | null;
  readonly artikelbezeichnung: string | null;
  readonly grundlage: string | null;
  readonly aktiv: boolean;
  readonly steuerschluessel: string;
  readonly steuerProzent: string | null;
  readonly steuerkategorie: string | null;
  readonly stufen: readonly Stufe[];
};

export async function alle(): Promise<readonly Staffelzeile[]> {
  const antwort = await rufe<{ readonly staffeln: readonly Staffelzeile[] }>('/gebuehrenstaffeln');
  return antwort.staffeln;
}

/**
 * Die Stufen als GANZES ersetzen (BUC-45, PRD-14).
 *
 * Zeilenweise gepflegt gäbe es zwischendurch immer einen Satz mit einer
 * Lücke — und in genau diesem Augenblick rechnet jemand eine Stornogebühr.
 */
export async function stufenSetzen(
  staffel: string,
  stufen: readonly { abTagenVorTermin: number; prozent?: string; nichtVorgesehen?: boolean }[],
): Promise<{ readonly stufen: number }> {
  return rufe(`/gebuehrenstaffeln/${staffel}/stufen`, { verfahren: 'PUT', rumpf: { stufen } });
}

export async function steuerSetzen(
  staffel: string,
  steuerschluessel: string,
): Promise<{ readonly steuerschluessel: string }> {
  return rufe(`/gebuehrenstaffeln/${staffel}/steuer`, {
    verfahren: 'PUT',
    rumpf: { steuerschluessel },
  });
}
